import React from 'react';
import { isNil } from '@packages/helpers/core/common';
import { formatValueToPercent } from '../../../helpers/formatters';
import { toMoneyStringWithComma, toMoneyStringWithK } from '../../../helpers/formatters/money-format';
import { PropertyStat } from '../../../components/property/stat';

export const MarketValue = React.memo(({ value, label, placeholder = '___', handleClick, ...props }) => (
  <PropertyStat
    name='property-market-value'
    label='Market value'
    value={!isNil(value) || !isNaN(value) ? toMoneyStringWithK(value) : placeholder}
    {...props}
  />
));

export const ValueGrowth = React.memo(({ value, placeholder = '___', ...props }) => (
  <PropertyStat
    name='property-value-growth'
    label='Value growth over 12 months'
    value={!isNil(value) || !isNaN(value) ? formatValueToPercent(value) : placeholder}
    {...props}
  />
));

export const RentalValue = React.memo(({ value, placeholder = '___', ...props }) => {
  const formattedValue =
    !isNil(value) || !isNaN(value) ? toMoneyStringWithComma(Number(value).toFixed(0)) : placeholder;
  return <PropertyStat name='property-rental-value' label='Rental value' value={formattedValue} {...props} />;
});
